import { useEffect, useRef, useState } from "react";
import axios from "axios";

// Aktuelles Popup aus dem Admin (Text oder Bild), einmal pro Seitenaufruf der Startseite.
export default function PopupModal() {
    const [popup, setPopup] = useState(null);
    const [open, setOpen] = useState(false);
    const closeRef = useRef(null);

    useEffect(() => {
        axios
            .get("/api/public/popups/active/latest")
            .then((res) => {
                if (res.data && res.data._id) {
                    setPopup(res.data);
                    setOpen(true);
                }
            })
            .catch(() => setOpen(false));
    }, []);

    useEffect(() => {
        if (!open) return undefined;
        const previous = document.activeElement;
        closeRef.current?.focus();
        const onKey = (e) => {
            if (e.key === "Escape") setOpen(false);
            // Einziges fokussierbares Element: Fokus bleibt auf dem Schließen-Button.
            if (e.key === "Tab") {
                e.preventDefault();
                closeRef.current?.focus();
            }
        };
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("keydown", onKey);
            previous?.focus?.();
        };
    }, [open]);

    if (!open || !popup) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-nacht/60 p-6"
            onClick={() => setOpen(false)}
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-label="Hinweis"
                className="relative max-h-[90vh] w-full max-w-[560px] overflow-auto bg-creme text-forest shadow-[0_24px_48px_rgba(14,22,18,.35)]"
                onClick={(e) => e.stopPropagation()}
            >
                {popup.type === "image" ? (
                    <img
                        src={`/api/public/popups/${popup._id}/image`}
                        alt="Aktueller Hinweis"
                        className="block max-h-[calc(90vh-80px)] w-full object-contain"
                    />
                ) : (
                    <div className="px-8 pt-10 pb-2 desk:px-10">
                        <div className="eyebrow mb-4">Aktuell</div>
                        <p className="whitespace-pre-line font-caslon text-[clamp(22px,2.4vw,28px)] leading-[1.35]">
                            {popup.text}
                        </p>
                    </div>
                )}
                <div className="flex justify-end px-8 py-6 desk:px-10">
                    <button
                        ref={closeRef}
                        type="button"
                        onClick={() => setOpen(false)}
                        className="btn btn-primary px-6 py-3.5"
                    >
                        Schließen
                    </button>
                </div>
            </div>
        </div>
    );
}
